<template>
  <footer>
    <div id="footer">
      <div class="container">
        <div class="row footer-link-container text-center">
          <!-- <div class="col-md-6">
            <ul class="contact-info">
              <li><i class="icon-envelope"></i><a href="mailto:taku-gym@legame-online.com" title="メールで問い合わせ">taku-gym@legame-online.com</a></li>
            </ul>
          </div>
           -->
          <div class="col-sm-3">
            <ul class="contact-info">
              <li><a href="/company" title="運営会社">運営会社</a></li>
            </ul>
          </div>
          <div class="col-sm-3">
            <ul class="contact-info">
              <li><a href="/static/rules.pdf" title="利用規約" target="_blank">利用規約</a></li>
            </ul>
          </div>
          <div class="col-sm-3">
            <ul class="contact-info">
              <li><a href="/contact" title="お問合せ">お問合せ</a></li>
            </ul>
          </div>
          <div class="col-sm-3">
            <ul class="contact-info">
              <li><a href="/privacy" title="個人情報保護方針">個人情報保護方針</a></li>
            </ul>
          </div>
        </div>
        <div class="row copy-right">
          <div class="col-md-6 col-md-offset-3 text-center">
            <p class="fh5co-social-icons">
              <a href="https://twitter.com/legame_online" target="_blank" rel="noopener noreferrer"><i
                  class="icon-twitter2"></i></a>
              <a href="https://vt.tiktok.com/ZSJACkDCG/" target="_blank" rel="noopener noreferrer"><i
                  class="icon-video-camera"></i></a>
              <a href="https://www.instagram.com/legame_online/" target="_blank" rel="noopener noreferrer"><i
                  class="icon-instagram"></i></a>
              <a href="https://www.youtube.com/channel/UC5P7VcBCx3nWTEJuge2dtGQ/featured" target="_blank"
                rel="noopener noreferrer"><i class="icon-youtube"></i></a>
            </p>
            <h3>君の脂肪を燃やし隊</h3>
            <p>- I want to burn your fat -</p>
            <p>
              脂肪を燃焼させることは決して楽なものではなく。
              むしろ大変ですし、ひとりでは難しいのが現状。
              そんな皆様を助けるべく結成されたのが
              【君の脂肪を燃やし隊】!
              隊長・副隊長・管理栄養士の３人が
              それぞれの得意な分野を生かして、皆様をサポート
              この世に蔓延る脂肪を燃焼させたい、そんな気持ちでいっぱいです!
            </p>
            <p>
              主な活動内容は
              脂肪を燃やしたい皆様へ向けての情報を日々発信中
              楽しい脂肪燃焼アプローチ方法をご紹介
              今後も様々な活動を展開していきたいと思います。
            </p>
            <p>
              私たち【君の脂肪を燃やし隊】と一緒に活動しませんか?</p>
            <p>
              R2もの補助により作成
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#footer h3 {
  font-size: 18px;
  color: #999;
  margin: 20px 0 10px;
}

.contact-info {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue